import * as URI from 'uri-js'
import urljoin from 'url-join'

/**
 */
export const resolve = (...paths) => {

  return URI.resolve(process.env.GATSBY_IMAGE_BASEURI, urljoin('./', ...paths))
}
